export default __webpack_public_path__ + "img/c2e9d7a2f3e7d529afb48723a4cba803.png";